import { Skeleton } from "@aurem/ui";

export const LoadingState = () => {
  return (
    <div className="flex flex-col gap-1">
      <Skeleton className="w-full h-10 rounded-xl" />
      <Skeleton className="w-full h-10 rounded-xl" />
      <Skeleton className="w-full h-10 rounded-xl" />
      <Skeleton className="w-full h-10 rounded-xl" />
      <Skeleton className="w-full h-10 rounded-xl" />
    </div>
  );
};
